
import { applyMiddleware, combineReducers, compose, createStore } from "redux"
import thunk from "redux-thunk"
import pgdReducer from "../Redux/PGD"
import asignacionesReducer from "../Redux/asignaciones"
import asignacionesActividadesReducer from "../Redux/asignacionesActividades"
import autocompletadosReducer from "../Redux/autocompletados"
import evaluacionesReducer from "../Redux/evaluaciones"
import ghRespondeReducer from "../Redux/ghResponde"
import legajoReducer from "../Redux/legajo"
import licenciasReducer from "../Redux/licencias"
import mensajesReducer from "../Redux/mensajes"
import novedadesLiquidacionReducer from "../Redux/novedadesLiquidacion"
import tokenReducer from "../Redux/token"
import universidadInternaReducer from "../Redux/universidadInterna"
import usuariosReducer from "../Redux/usuarios"
import vacacionesReducer from "../Redux/vacaciones"
import solicitudesReducers from '../Redux/solicitudes';
import desempenoReducer from "../Redux/desempeno"
import formacionReducer from "../Redux/formacion"
import comitesReducer from "../Redux/comitesJurados"
import cientificasReducer from "../Redux/reunionesCientificas"
import trayectoriaReducer from "../Redux/trayectoriaDocente"
import investigacionReducer from "../Redux/investigacion"
import organigramaReducer from "../Redux/organigrama"


const appReducer = combineReducers({
  autocompletados: autocompletadosReducer,
  usuarios: usuariosReducer,
  token: tokenReducer,
  mensajes: mensajesReducer,
  licencias: licenciasReducer,
  vacaciones: vacacionesReducer,
  pgd: pgdReducer,
  ghResponde: ghRespondeReducer,
  universidadInterna: universidadInternaReducer,
  novedadesLiquidacion: novedadesLiquidacionReducer,
  evaluaciones: evaluacionesReducer,
  solicitudes: solicitudesReducers,
  legajo: legajoReducer,
  asignaciones: asignacionesReducer,
  asignacionesActividades: asignacionesActividadesReducer,
  desempeno: desempenoReducer,
  formacion: formacionReducer,
  comites: comitesReducer,
  cientificas: cientificasReducer,
  trayectoria: trayectoriaReducer,
  investigacion: investigacionReducer,
  organigrama: organigramaReducer
})

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'CERRAR_SESION') {
    state = undefined;
  }

  return appReducer(state, action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function generateStore() {
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
  return store
}